import { getFullVelocityUrl } from '@/Helper';
import { User } from '@/model/AccountModel';
import { Button, Layout, Menu, MenuProps, Tooltip } from 'antd';
import React, { CSSProperties } from 'react';
import {
	AlarmsIcon,
	DeviceControlIcon,
	EnrollmentIcon,
	EventsIcon,
	MenuCloseIcon,
	MenuOpenIcon,
	PhotoCallUpIcon,
	ReportingIcon,
	StatusDashboardIcon,
	StatusViewerIcon,
	VelocityVisionIcon,
	WhosInsideIcon,
} from './MenuIcons';
import styles from './header.module.scss';

const { Sider } = Layout;

type Props = {
	collapsed: boolean;
	handleOnCollapseMenu: () => void;
};

//Avoid creating object style inline, since increases reconciliations
const user: User = getUser();
const {
	canViewEnrollmentPage,
	canViewAlarmPage,
	canViewReportsPage,
	canViewEventsPage,
	canViewWhosInside,
	canViewDevicePage,
	canViewDashboard,
	canViewPhotoCallUp,
	canViewStatusViewer,
	canViewGraphic,
	canViewBadge,
	canViewVelocityVision,
} = user;

const companyName: string = 'Hirsch, Inc.';
const fullVelocityUrl: string = getFullVelocityUrl();
const enrollmentUrl: string = `${fullVelocityUrl}Enrollment/EnrollmentManager`;
const alarmsUrl: string = `${fullVelocityUrl}Events/EventViewer`;
const eventsUrl: string = `${fullVelocityUrl}Events/FullEventViewer`;
const deviceAdminManagerUrl: string = `${fullVelocityUrl}DeviceAdmin/DeviceAdminManager`;
const statusViewerUrl: string = `${fullVelocityUrl}StatusViewer/StatusViewer`;
const whosInsideUrl: string = `${fullVelocityUrl}WhosInside/WhosInsideManager`;
const photoCallUpUrl: string = `${fullVelocityUrl}PhotoCallUp/PhotoCallUpDashboard`;
const reportsUrl: string = `${fullVelocityUrl}Reports/ReportManager`;
const statusDashboardUrl: string = `${fullVelocityUrl}Status/StatusDashboard`;
const graphicUrl: string = `${fullVelocityUrl}Graphic/Graphic`;
const badgeUrl: string = `${fullVelocityUrl}Graphic/Badge`;
const velocityVisionUrl: string = `${fullVelocityUrl}VelocityVision/VelocityVisionManager`;
const iconsStyle: CSSProperties = { color: 'white', width: 16 };
const MenuCollapseStyle: CSSProperties = { width: '20px', fill: '#fff' };

const Header: React.FC<Props> = ({ collapsed, handleOnCollapseMenu }) => {
	let activeKey: string = '-1';
	const input = document.getElementById('SelectedTab') as HTMLInputElement;

	if (input && input.value) {
		activeKey = input.value;
	}

	const menuItems: MenuProps['items'] = [];
	if (canViewEnrollmentPage) {
		menuItems.push({
			key: '1',
			icon: <EnrollmentIcon label={_('Enrollment')} style={iconsStyle} />,
			label: (
				<span id='enrollmentManagerPageTab'>
					<a href={enrollmentUrl} data-leavetab={true}>
						&nbsp;{_('Enrollment')}
					</a>
				</span>
			),
		});
	}
	if (canViewAlarmPage) {
		menuItems.push({
			key: '2',
			icon: <AlarmsIcon label={_('AlarmViewer')} style={iconsStyle} />,
			label: (
				<span id='alarmsPageTab'>
					<a href={alarmsUrl} data-leavetab={true}>
						&nbsp;{_('AlarmViewer')}
					</a>
				</span>
			),
		});
	}
	if (canViewEventsPage) {
		menuItems.push({
			key: '3',
			icon: <EventsIcon label={_('Events')} style={iconsStyle} />,
			label: (
				<span id='eventsPageTab'>
					<a href={eventsUrl} data-leavetab={true}>
						&nbsp;{_('EventViewer')}
					</a>
				</span>
			),
		});
	}
	if (canViewDevicePage) {
		menuItems.push({
			key: '4',
			icon: <DeviceControlIcon label={_('DeviceControl')} style={iconsStyle} />,
			label: (
				<span id='deviceControlPageTab'>
					<a href={deviceAdminManagerUrl} data-leavetab={true}>
						&nbsp;{_('DeviceControl')}
					</a>
				</span>
			),
		});
	}
	if (canViewStatusViewer) {
		menuItems.push({
			key: '5',
			icon: <StatusViewerIcon label={_('StatusViewer')} style={iconsStyle} />,
			label: (
				<span id='statusViewerPageTab'>
					<a href={statusViewerUrl} data-leavetab={true}>
						&nbsp;{_('StatusViewer')}
					</a>
				</span>
			),
		});
	}
	if (canViewWhosInside) {
		menuItems.push({
			key: '6',
			icon: <WhosInsideIcon label={_('WhosInside')} style={iconsStyle} />,
			label: (
				<span id='whosInsidePageTab'>
					<a href={whosInsideUrl} data-leavetab={true}>
						&nbsp;{_('WhosInside')}
					</a>
				</span>
			),
		});
	}
	if (canViewPhotoCallUp) {
		menuItems.push({
			key: '7',
			icon: <PhotoCallUpIcon label={_('PhotoCallUp')} style={iconsStyle} />,
			label: (
				<span id='photoCallUpPageTab'>
					<a href={photoCallUpUrl} data-leavetab={true}>
						&nbsp;{_('PhotoCallUp')}
					</a>
				</span>
			),
		});
	}
	if (canViewReportsPage) {
		menuItems.push({
			key: '8',
			icon: <ReportingIcon label={_('Reporting')} style={iconsStyle} />,
			label: (
				<span id='reportingPageTab'>
					<a href={reportsUrl} data-leavetab={true}>
						&nbsp;{_('Reporting')}
					</a>
				</span>
			),
		});
	}
	if (canViewDashboard) {
		menuItems.push({
			key: '9',
			icon: <StatusDashboardIcon label={_('StatusDashboard')} style={iconsStyle} />,
			label: (
				<span id='statusDashboardPageTab'>
					<a href={statusDashboardUrl} data-leavetab={true}>
						&nbsp;{_('StatusDashboard')}
					</a>
				</span>
			),
		});
	}
	/* if (canViewGraphic) {
			menuItems.push({
				key: '10',
				icon: <MapDirectoryNoFolderIcon aria-label={_('Maps')} elementStyle={{ ...iconsStyle, width: '20px', marginRight: '6px' }} />,
				label: (
					<span id='graphicsPageTab'>
						<a href={graphicUrl} data-leavetab={true}>
							&nbsp;{_('Maps')}
						</a>
					</span>
				),
			});
		}
		if (canViewBadge) {
		 	menuItems.push({
		 		key: '11',
		 		icon: <BadgeStudioIcon style={{ fontSize: 16 }} />,
		 		label: (
		 			<span id='badgePageTab'>
		 				<a href={badgeUrl} data-leavetab={true}>
		 					&nbsp;{_('Badge')}
		 				</a>
		 			</span>
		 		),
			});
		} */
	if (canViewVelocityVision) {
		menuItems.push({
			key: '12',
			icon: <VelocityVisionIcon label={_('VelocityVision')} style={iconsStyle} />,
			label: (
				<span id='velocityVisionTab'>
					<a href={velocityVisionUrl} data-leavetab={true}>
						&nbsp;{_('VelocityVision')}
					</a>
				</span>
			),
		});
	}

	return (
		<>
			<Sider className={styles.headerMenuContainer} trigger={null} collapsible collapsed={collapsed} collapsedWidth={50}>
				<div className={styles.logoContainer}>
					<img alt={companyName} src={`${fullVelocityUrl}Content/Images/logo_small.png?_=${getScriptVersion()}`} hidden={collapsed} />
					<div className={styles.menuButton}>
						<Tooltip key={collapsed.toString()} placement='left' title={collapsed ? _('ClickToExpandMenu') : _('ClickToCollapseMenu')}>
							<Button id='buttonCollapseMenu' onClick={handleOnCollapseMenu}>
								{collapsed ? (
									<MenuOpenIcon label={`${_('Menu')} ${_('Fold')}`} style={MenuCollapseStyle} />
								) : (
									<MenuCloseIcon label={`${_('Menu')} ${_('Unfold')}`} style={MenuCollapseStyle} />
								)}
							</Button>
						</Tooltip>
					</div>
				</div>
				<Menu
					className={styles.headerMenu}
					defaultSelectedKeys={[activeKey]}
					getPopupContainer={(element: HTMLElement) => element.parentElement}
					items={menuItems}
					mode='inline'
				/>
			</Sider>
		</>
	);
};

export { Header };
